import { TagLang, TagType } from '../../__generated__/queries-web';

export const allowedTagTypes = [
  TagType.Person,
  TagType.Tag,
  TagType.Company,
  TagType.Destination,
];

export const tagLangLabelByValue: Record<TagLang, string> = {
  [TagLang.FR]: 'Français',
  [TagLang.EN]: 'Anglais',
  [TagLang.DE]: 'Allemand',
  [TagLang.ES]: 'Espagnol',
  [TagLang.IT]: 'Italien',
  [TagLang.PT]: 'Portugais',
};
